// extracted by mini-css-extract-plugin
export default {"companyRequestForm":"AddCompanyRequest_companyRequestForm__pVcwq"};